import React from 'react'

const ErrorText = ({ className = undefined, children }) => {
	return <div className="text-xs text-red-600">{children}</div>
}

export default ErrorText
